var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHassleFree = function SvgHassleFree(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1309 30.3158L22.1836 35.3684H32.2105V48H19.5789V38.1221L15.5608 34.104L0 34.1053V30.3158H17.1309ZM28.421 39.1579H23.3684V44.2105H28.421V39.1579ZM48.6316 17.6842V30.3158H36V25.8947H0V22.1053H36V17.6842H48.6316ZM44.8421 21.4737H39.7895V26.5263H44.8421V21.4737ZM32.2105 0V12.6316H21.9789L17.1309 17.4821H0V13.6926L15.5608 13.6914L19.5789 9.67326V0H32.2105ZM28.421 3.78947H23.3684V8.8421H28.421V3.78947Z",
    fill: "#031FEF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHassleFree, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hassleFree.448583fd.svg";
export { ForwardRef as ReactComponent };